export default "__VITE_ASSET__B0$DAOAL__"